"use client";

import React from "react";
import HeroSection from "./HeroSection";
import WhyJoinSection from "./WhyJoinSection";
import MentorsSection from "./MentorsSection";
import SolutionsSection from "./SolutionsSection";
import BenefitsSection from "./BenefitsSection";
import HowItWorksSection from "./HowItWorksSection";
import TrainingSection from "../Common/TrainingSection";
import ApplicationFormSection from "./ApplicationFormSection";
import FooterCTASection from "./FooterCTASection";
import Faq from "../Common/Faq";

const EnseignerContent: React.FC = () => {
    return (
        <div className="flex flex-col min-h-screen bg-white overflow-hidden">
            <HeroSection />

            {/* 2. Value proposition and why join */}
            <WhyJoinSection />

            {/* 3. Business models and solutions */}
            <SolutionsSection />

            {/* 4. Detailed benefits and target audience */}
            <BenefitsSection />

            {/* 5. Process explanation */}
            <HowItWorksSection />

            {/* 6. Persona-based advantages */}
            <TrainingSection enseigner={true} />

            {/* 7. Final bottom CTA */}
            <FooterCTASection />

            {/* 8. Social proof and expert network */}
            <MentorsSection />

            {/* 9. Conversion point: Application form */}
            <ApplicationFormSection />

            {/* 10. FAQ section */}
            <Faq slug='enseigner' />

        </div>
    );
};

export default EnseignerContent;
